export const commonFetcher = async <T>(url: URL): Promise<T> => {
  const response = await fetch(url, {
    method: "GET",
    headers: [["accepts", "application/json"]],
  });

  if (response.status !== 200) {
    throw response.status;
  }

  return await response.json();
};
